import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Button, Form, Select, Table, Col, Row, Tabs } from "antd";

import { ReadCookie } from "../../utils/readCookie";
import { TabTitle } from "../../utils/GeneralFunction";
import { getMacysInvoice, getMacysOrders, sendMacysInvoice, SendMacysOrders } from "../../redux/actions/macysOrders.action";
import moment from "moment";
import numeral from "numeral";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import notification from "../../utils/notification";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const { Option } = Select;
const { TabPane } = Tabs;

const MacysOrders = () => {
    TabTitle("Macys Orders");
    const [form] = Form.useForm();
    const [minimize, setMinimize] = useState(false);
    const dispatch = useDispatch();
    const menuId = ReadCookie("menuId");
    const token = ReadCookie("token");
    const { macysOrders } = useSelector((state) => state);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [loading, setLoading] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        dispatch(getMacysOrders(token));
    }, [dispatch, token]);

    const Cols = [
        {
            title: "#",
            // width: 25,
            render: (text, record, index) => index + 1,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            // width: 320,
            render: (text, record) => (
                <div
                    onClick={() => setSelectedOrder(record)}
                    title={text}
                    style={{
                        fontSize: '13px',
                        maxWidth: '300px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: 'pointer',
                    }}
                >
                    {text}
                </div>
            ),
        },
        {
            title: "Orders",
            render: (text, record) => <>{record?.orders?.length}</>,
        },
        {
            title: "Orders Status",
            dataIndex: "order_status",
            key: "order_status",
        },
    ];

    const Headcolumns = [
        {
            title: "Order #",
            dataIndex: "custOrderNumber",
            key: "custOrderNumber",
        },
        {
            title: "PO Number",
            dataIndex: "poNumber",
            key: "poNumber",
        },
        {
            title: "Customer",
            render: (text, record) => <>{record?.shipping_lines?.addressee}</>,
        },
        {
            title: "Order Date",
            dataIndex: "orderDate",
            key: "orderDate",
            render: (text, record) => <>{moment(text).format("MM-DD-YYYY")}</>,
        },
        {
            title: "Cancel Date",
            dataIndex: "cancelDate",
            key: "cancelDate",
            render: (text, record) => <>{moment(text).format("MM-DD-YYYY")}</>,
        },
        {
            title: "Expected Ship Date",
            dataIndex: "expectedShipDate",
            key: "expectedShipDate",
            render: (text, record) => <>{moment(record?.lineItems[0]?.expectedShipDate).format("MM-DD-YYYY")}</>,
        },
        {
            title: "Total Qty",
            key: "totalQtyOrdered",
            render: (text, record) => {
                const totalQty = record?.lineItems?.reduce((sum, item) => sum + parseFloat(item?.qtyOrdered || 0), 0);
                return totalQty;
            },
        },
        {
            title: "Balance Due",
            dataIndex: "balanceDue",
            key: "balanceDue",
            // align:"right",
            render: (text, record) => <>{numeral(text).format("$0,0.00")}</>,
        },
    ];

    const lineItemColumns = [
        {
            title: "UPC",
            dataIndex: "upc",
            key: "upc",
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "Qty Ordered",
            dataIndex: "qtyOrdered",
            key: "qtyOrdered",
        },
        {
            title: "Unit Price",
            dataIndex: "unitPrice",
            key: "unitPrice",
            align: "right",
            render: (text, record) => <>{numeral(text).format("$0,0.00")}</>,
        },
        {
            title: "Unit Cost",
            dataIndex: "unitCost",
            key: "unitCost",
            align: "right",
            render: (text, record) => <>{numeral(text).format("$0,0.00")}</>,
        },
    ];


    const exportToExcel = (selectedOrder) => {
        const rows = [];

        selectedOrder.orders.forEach(order => {
            order.lineItems.forEach(line => {
                rows.push({
                    poNumber: order.poNumber,
                    orderDate: order.orderDate,
                    tax: order.tax,
                    shipping: order.shipping,
                    balanceDue: order.balanceDue,
                    salesDivision: order.salesDivision,
                    shippingCode: order.shippingCode,
                    cancelDate: order.cancelDate,
                    currency: order.currency,
                    custOrderNumber: order.custOrderNumber,

                    // Shipping address fields
                    shippingAddressee: order.shipping_lines?.addressee || '',
                    shippingAddress1: order.shipping_lines?.address1 || '',
                    shippingAddress2: order.shipping_lines?.address2 || '',
                    shippingCity: order.shipping_lines?.city || '',
                    shippingState: order.shipping_lines?.state || '',
                    shippingPostalCode: order.shipping_lines?.postalCode || '',
                    shippingCountry: order.shipping_lines?.country || '',
                    shippingEmail: order.shipping_lines?.email || '',

                    // Billing address fields
                    billingAddressee: order.billing_lines?.addressee || '',
                    billingAddress1: order.billing_lines?.address1 || '',
                    billingAddress2: order.billing_lines?.address2 || '',
                    billingCity: order.billing_lines?.city || '',
                    billingState: order.billing_lines?.state || '',
                    billingPostalCode: order.billing_lines?.postalCode || '',
                    billingCountry: order.billing_lines?.country || '',
                    billingEmail: order.billing_lines?.email || '',

                    // Line item fields
                    lineItemId: line.lineItemId,
                    qtyOrdered: line.qtyOrdered,
                    unitPrice: line.unitPrice,
                    unitCost: line.unitCost,
                    description: line.description,
                    upc: line.upc,
                    expectedShipDate: line.expectedShipDate,
                });
            });
        });

        // Convert to worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

        // Save as file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'MacysOrders.xlsx');
    };


    const onFinish = (selectedOrder) => {
        setLoading(true);
        dispatch(SendMacysOrders(token, selectedOrder))
            .then((res) => {
                setLoading(false);

                if (res?.type === "ADD_MACYS_ORDERS_SUCCESS") {
                    notification("success", res?.payload?.message, "Orders sent successfully.");
                    setSelectedOrder(null);
                    dispatch(getMacysOrders(token));
                } else {
                    notification("error", "Failed to Send Orders", res?.payload?.message || "Unknown error occurred.");
                    console.error("Failed to send orders:", res?.payload?.message || "Unknown error");
                }
            })
            .catch((error) => {
                setLoading(false);
                notification("error", "Dispatch Error", error?.message || "Something went wrong while sending orders.");
                console.error("Dispatch failed:", error);
            });
    };



    const [spinner, setSpinner] = useState(true);
    const [activeTab, setActiveTab] = useState("orders")
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [macysInvoice, setMacysInvoice] = useState([]);

    const onSelectChange = (newSelectedRowKeys, selectedRows) => {

        setSelectedRows(selectedRows)
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    useEffect(() => {
        if (activeTab === "invoice") {
            setLoading(true);
            dispatch(getMacysInvoice(token)).then((res) => {
                setLoading(false);
                setSpinner(false);
                setMacysInvoice(res?.payload?.data);
            });
        }
    }, [dispatch, menuId, token, activeTab]);

    const invoiceColumns = [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: 'Inv #',
            dataIndex: 'invoice_header_no',
            key: 'invoice_header_no',
            width: 70,
        },
        {
            title: 'Inv Date',
            render: (text, record) => {
                return <>{moment(record.invoice_date).format("MM-DD-YYYY")}</>;
            },
            width: 90
        },
        {
            title: 'SO #',
            dataIndex: 'order_header_no',
            key: 'order_header_no',
            width: 80
        },
        {
            title: 'SO Date',
            dataIndex: 'order_date',
            key: 'order_date',
            width: 80,
            render: (text, record) => {
                return <>{moment(record.order_date).format("MM-DD-YYYY")}</>;
            },
        },
        {
            title: 'PT #',
            dataIndex: 'ship_header_no',
            key: 'ship_header_no',
            width: 80
        },
        {
            title: 'PT Date',
            dataIndex: 'ship_date',
            key: 'ship_date',
            width: 80,
            render: (text, record) => {
                return <>{moment(record.ship_date).format("MM-DD-YYYY")}</>;
            },
        },
        {
            title: 'PO #',
            dataIndex: 'reference_no',
            key: 'reference_no',
            width: 120
        },
        {
            title: 'Tracking #',
            dataIndex: 'tracking_no',
            key: 'tracking_no',
            width: 120
        },
    ];

    const sendToAll = ((selectedRows) => {
        setSpinner(true)
        let data = selectedRows?.map((item) => {
            return item.invoice_header_id
        })
        console.log("data", data)
        dispatch(sendMacysInvoice(token, data)).then((res) => {
            if (res.type === "ADD_MACYS_INVOICE_SUCCESS") {
                setSelectedRowKeys([]);
                setSelectedRows([]);
                dispatch(getMacysInvoice(token)).then((res) => {
                    setMacysInvoice(res?.payload?.data);
                    setSpinner(false)
                });
                notification("success", res?.payload?.message);
            }
        });
    })

    return (
        <div className="styleContainer">
            <style>
                {`
          .styleTable, .styleForm {
            background: #fff;
            padding: 1rem;
            border-radius: 6px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            margin: 1rem;
          }

          .order-summary {
            background: #f9f9f9;
            padding: 2rem;
            border-radius: 6px;
            margin-bottom: 1.5rem;
          }

          .order-summary hr {
            border: none;
            border-top: 1px solid #ddd;
            margin: 1rem 0;
          }

          .po-number-table .ant-table-thead > tr > th {
            background-color: #fafafa;
            font-weight: bold;
          }

          .nested-lineitem-table .ant-table-thead > tr > th {
            background-color: #f0f0f0;
          }

          .po-table .ant-table {
            border: 1px solid #eee;
            border-radius: 4px;
            overflow: hidden;
          }

          .send-order-btn {
            margin-bottom: 1rem;
          }
          .po-number-table .ant-table-body::-webkit-scrollbar {
            width: 12px;
            height: 12px; 
          }
                          
          .po-number-table .ant-table-body::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.3);
            border-radius: 6px;
          }
                          
          .po-number-table .ant-table-body::-webkit-scrollbar-track {
            background-color: #f1f1f1;
          }
          .po-number-table .ant-table-body {
            scrollbar-width: thin;
            scrollbar-color: rgba(0,0,0,0.3) #f1f1f1;
          }
        `}
            </style>

            <div className="styleBody h-100">
                <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}
                    type="card"
                    destroyInactiveTabPane >
                    <TabPane tab="Macys Orders" key="orders">
                        <PageHeader
                            title={"Macys Orders"}
                            minimize={setMinimize}
                            check={minimize}
                        />

                        {!minimize && (
                            <div className="bodyStyle">
                                <div className="styleContent">
                                    <Row className="tables-main-row-new" gutter={16}>
                                        <Col xs={24} sm={24} md={10} lg={8} xl={8}>
                                            <div className="styleTable">
                                                <Table
                                                    type="style"
                                                    scroll={{ x: "max-content" }}
                                                    perPage={25}
                                                    // dataSource={macysOrders?.payload?.files}
                                                    dataSource={
                                                        macysOrders?.payload?.files?.filter(item => item?.orders?.[0]?.orderDate)
                                                            ?.sort((a, b) => new Date(b.orders[0].orderDate) - new Date(a.orders[0].orderDate)) || []
                                                    }
                                                    columns={Cols}
                                                    pagination
                                                    loading={macysOrders?.loading}
                                                />
                                            </div>
                                        </Col>

                                        <Col xs={24} sm={24} md={14} lg={16} xl={16}>
                                            <div className="styleForm">
                                                <div className="testStyle">
                                                    {selectedOrder ? (
                                                        <>
                                                            <div className="order-summary">
                                                                <div className="d-flex " style={{ justifyContent: "space-between", alignItems: "center" }}>
                                                                    <h3>Order Details</h3>
                                                                    <Button onClick={() => exportToExcel(selectedOrder)}
                                                                        type="primary"
                                                                        className="send-order-btn">
                                                                        Export Orders to Excel
                                                                    </Button>
                                                                </div>
                                                                <p>
                                                                    <strong>Name:</strong> {selectedOrder.name}
                                                                </p>
                                                                <p>
                                                                    <strong>Order Count:</strong>{" "}
                                                                    {selectedOrder?.orders?.length}
                                                                </p>
                                                                <hr />
                                                                <Button
                                                                    type="primary"
                                                                    className="send-order-btn"
                                                                    loading={loading}
                                                                    onClick={() => {
                                                                        onFinish(selectedOrder);
                                                                    }}
                                                                    disabled={selectedOrder?.order_status === "Success"}
                                                                >
                                                                    Create Order
                                                                </Button>
                                                            </div>

                                                            <div className="po-table">
                                                                <Table
                                                                    columns={Headcolumns}
                                                                    dataSource={selectedOrder.orders}
                                                                    rowKey={(record, index) => index}
                                                                    expandable={{
                                                                        expandedRowRender: (record) => (
                                                                            <Table
                                                                                columns={lineItemColumns}
                                                                                dataSource={record.lineItems}
                                                                                pagination={false}
                                                                                rowKey={(item) => item.lineItemId}
                                                                                className="nested-lineitem-table"
                                                                                scroll={{ x: "max-content" }}
                                                                            />
                                                                        ),
                                                                        rowExpandable: (record) =>
                                                                            record.lineItems && record.lineItems.length > 0,
                                                                    }}
                                                                    pagination={false}
                                                                    className="po-number-table po-table"
                                                                    scroll={{ x: "max-content", y: 450 }} // 👈 vertical scroll added here
                                                                />

                                                            </div>
                                                        </>
                                                    ) : (
                                                        <h3>Select a name to view order details.</h3>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        )}
                    </TabPane>

                    <TabPane tab="Macys Invoice" key="invoice">
                        <div>
                            {selectedRows.length ?
                                <Button
                                    onClick={() => sendToAll(selectedRows)}
                                >
                                    Send {selectedRows.length} Invoice
                                </Button> : ""
                            }
                        </div>
                        <Table
                            rowSelection={{ ...rowSelection }}
                            rowKey={(record) => record.invoice_header_id}
                            ref={tableRef}
                            size="small"
                            bordered={false}
                            type="company"
                            scroll={{ x: 'max-content', y: 700 }}
                            pagination={{ pageSize: 1000 }}
                            dataSource={macysInvoice}
                            columns={invoiceColumns}
                            loading={spinner}
                            paginate
                            rowClassName={(record) => record.is_email ? "odd" : ''}
                        />
                    </TabPane>
                </Tabs>
            </div>

            {
                minimize && (
                    <div className="styleFooter">
                        <Button
                            className="minimize-button-style"
                            onClick={() => setMinimize(false)}
                        >
                            Style
                        </Button>
                    </div>
                )
            }
        </div >
    );
};

export default MacysOrders;
